import { Breadcrumb as ChakraBreadcrumb } from "@chakra-ui/react";
import {
  Children,
  Fragment,
  isValidElement,
  type ComponentProps,
  type PropsWithChildren,
  type ReactNode,
} from "react";
import type { BreadcrumbSharedProps } from "./Breadcrumb.props";

type ChakraBreadcrumbRootProps = ComponentProps<typeof ChakraBreadcrumb.Root>;

export type BreadcrumbProps = PropsWithChildren<
  BreadcrumbSharedProps &
    Omit<ChakraBreadcrumbRootProps, "children"> & {
      // v1/v2 API
      separator?: ReactNode;
      spacing?: ComponentProps<typeof ChakraBreadcrumb.List>["gap"];
    }
>;

export default function Breadcrumb(props: BreadcrumbProps): JSX.Element {
  const { children, separator = "/", spacing, ...rest } = props;

  const validChildren = Children.toArray(children).filter(isValidElement);

  return (
    <ChakraBreadcrumb.Root {...rest}>
      <ChakraBreadcrumb.List gap={spacing}>
        {validChildren.map((child, index) => {
          const last = index === validChildren.length - 1;
          return (
            // eslint-disable-next-line react/no-array-index-key
            <Fragment key={index}>
              {child}
              {!last && (
                <ChakraBreadcrumb.Separator>
                  {separator}
                </ChakraBreadcrumb.Separator>
              )}
            </Fragment>
          );
        })}
      </ChakraBreadcrumb.List>
    </ChakraBreadcrumb.Root>
  );
}
